import React, { useEffect } from "react";
import { useState } from "react";
import { IState } from "./IState";
import {
  mdiHomeVariantOutline,
  mdiAccountFilterOutline,
  mdiFolderOutline,
  mdiFilePlusOutline,
  mdiTestTube,
  mdiLinkBoxOutline,
} from "@mdi/js";
import { route, getAxios } from "../../utils/endpoints";
import { IProps as SidebarContentProps } from "../SidebarContent/IProps";
import { SideBarMenu } from "../../types/SidebarMenu";
import { useLocation, Link } from "react-router-dom";
import { User } from "../../model/User";
import { useSelector } from "react-redux";
import { RootState } from "../../state/reducers";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state";
import { useSidebar } from "../../hooks/use-sidebar";

export const usePageLayout = () => {
  const { pathname } = useLocation();

  const { sidebarContent, isLoading, error, loadSidebar } = useSidebar();

  const user = new User();

  const onMe = async () => {
    const response = await getAxios("/me", "GET");

    const data = await response.data;

    user.SaveSession(data);
  };

  useEffect(() => {
    loadSidebar();
  }, [loadSidebar]);

  useEffect(() => {
    onMe();
  }, [pathname]);

  return {
    content: sidebarContent,
    isLoading,
    error,
  };
};
